import type { FaireProductEntity } from "../../entity_types/product";

export const p_325erbmv35: FaireProductEntity = {
  token: "p_325erbmv35",
  type: "product",
  name: "RAWMYGOD Nut Butter Balls - Cherry & Peanut",
  brandToken: "b_46hn96hpk5",
  brandName: "Wilton Mettler LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/830b9b2887ba3a443b6fc57e75e509765be8eeffc0a3cb091ab5aba880a9ba4a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b6d1fccd4e4b46de9883a525976259b9f808cf3b74b417bd08b8f62ae22b90d0.jpeg",
    "https://cdn.faire.com/fastly/a9b7ea66336d8a334b44efc767aa2561b0a01b1bcaa6e6b623a5d87a38438927.jpeg",
    "https://cdn.faire.com/fastly/0bc8eaeb8b179f9bd474486abe02eddfb85ea0a0b015470a431f8ac91610afc4.jpeg",
  ],
  priceDollars: 3.67,
  description:
    "\nGluten Free, Vegan, No Added Sugar\n\nNutritious Snack: Made with wholesome ingredients like dates, peanuts, dried cherries, almond powder, and pea protein, with a creamy peanut butter center.\n\nIndulgent Treat: A naturally sweet, protein-packed delight with a vibrant cherry and nutty flavor\n\nVersatile Delight: Perfect as a snack, dessert, or energy boost anytime.\n\nCold-processed to preserve nutritional value; not heated above 104° Fahrenheit\n\nExperience RAWMYGOD NUT BUTTER BALLS CHERRY & PEANUT, where sweet dates meet crunchy peanuts and tangy dried cherries, all encased in a smooth peanut butter center. These bite-sized treats combine a delightful variety of textures with bold, fruity notes and a rich nutty finish. Made with premium ingredients, they’re a nourishing snack you can enjoy anytime. Ideal for a quick pick-me-up or a delicious treat to enjoy solo or with friends. \n",
  tags: [],
  msrpDollars: 6.58,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:15.921Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
